import { faArrowRight, faCircle, faDotCircle, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Flex, Spin } from "antd"
import './TransportListItem.less'
import { memo } from "react"
import { useLocation } from "react-router-dom"
import { LoadingOutlined } from "@ant-design/icons"

const TransportListItem = ({ data, onViewStops, key, loading }) => {
    const { _id, route, destination, arrival_time: eta, next_eta, second_next_eta, stops } = data
    const location = useLocation()
    const pathname = location.pathname
    // Only "From HKUST > Bus Stops" lists routes by gate, so show their destination.
    const showDestination = pathname.includes('/from-hkust/bus-stops')

    const getMinutes = (date) => {
        if (!date) {
            return '~'
        }
        const targetDate = new Date(date)
        const now = new Date()

        const difference = targetDate - now
        const minutes = Math.floor(difference / (1000 * 60))

        if (isNaN(minutes)) {
            return '~'
        }
        return minutes < 0 ? 0 : minutes
    }


    return (
        <div className="transport-card" key={key}>
            <div className="decor">
                <FontAwesomeIcon icon={faCircle} fontSize={10} className="icon" />
                <div className="line"></div>
                <FontAwesomeIcon icon={faMapMarkerAlt} fontSize={16} className="icon" />
            </div>
            <div className="body">
                <p>
                    <span>
                        <span className="number">{route}</span> {showDestination ? <span className="title">(To {destination})</span> : null}
                    </span>
                    <Button onClick={() => onViewStops(data)} type="link" style={{ padding: 0, height: 'unset' }} icon={loading && <Spin style={{ display: 'block' }} indicator={<LoadingOutlined spin style={{ fontSize: 12 }} />} size="default" />}>View Stops</Button>
                </p>
                <p>
                    <span>Arriving in</span>
                    <span>
                        <span className="time number active">{getMinutes(eta)}</span>
                        min(s)
                    </span>
                </p>
                <p className="following">
                    <span>Next</span>
                    <span>
                        <span className="time number">{getMinutes(next_eta)}</span>
                        min(s)
                    </span>
                </p>
                <p className="following">
                    <span>2nd Next</span>
                    <span>
                        <span className="time number">{getMinutes(second_next_eta)}</span>
                        min(s)
                    </span>
                </p>
            </div>
        </div>
    )
}

export default memo(TransportListItem, (prev, next) =>
    prev.data.arrival_time === next.data.arrival_time &&
    prev.data.next_eta === next.data.next_eta &&
    prev.data.second_next_eta === next.data.second_next_eta
)